import { render, staticRenderFns } from "./OrdersAdmin.vue?vue&type=template&id=3ae26699&scoped=true&"
import script from "./OrdersAdmin.vue?vue&type=script&lang=js&"
export * from "./OrdersAdmin.vue?vue&type=script&lang=js&"
import style0 from "./OrdersAdmin.vue?vue&type=style&index=0&id=3ae26699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae26699",
  null
  
)

export default component.exports